// extracted by mini-css-extract-plugin
export var card = "_oh-0";
export var content = "_oh-2";
export var details = "_oh-3";
export var icon = "_oh-1";
export var iconBlue = "_oh-5";
export var iconBrand = "_oh-4";
export var iconGrayBlue = "_oh-6";
export var iconGreen = "_oh-7";
export var iconIndigo = "_oh-8";
export var iconOrange = "_oh-9";
export var iconPurple = "_oh-a";
export var iconRed = "_oh-b";
export var iconWarning = "_oh-c";